import { useCallback, useEffect } from "react";

import { useSearchParams } from "react-router-dom";

export default function useProfile() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "";

  const changeTab = useCallback(
    (tab: string) => {
      searchParams.set("tab", tab);
      setSearchParams(searchParams, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  useEffect(() => {
    if (!["aboutMe", "findings", "clinic"].includes(activeTab)) {
      changeTab("aboutMe");
    }
  }, [activeTab, changeTab]);

  return { activeTab, changeTab };
}
